var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',_vm._b({attrs:{"centered":"","size":"xl","hide-header":"","hide-footer":"","body-class":"p-0","no-close-on-backdrop":"","no-close-on-esc":""}},'b-modal',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }